// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3MJRbec1Aq9vFd {\n  display: none;\n}\n._2Q5KuGbSQziQGb {\n  display: flex;\n  position: relative;\n  margin: 0 0 8px;\n}\n._2Q5KuGbSQziQGb:first-child {\n  margin-top: 2px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hiddenListItem": "_3MJRbec1Aq9vFd",
	"listItem": "_2Q5KuGbSQziQGb"
};
export default ___CSS_LOADER_EXPORT___;
